import { useTranslation } from 'react-i18next'

import { Status } from '../../../Status'
import {
  MATCH_ELIGIBILITY_STATUSES,
  QA_NAME_MATCH_ELIGIBILITY_BADGE,
} from '../RentalPortalMatch.constants'
import { getMatchEligibilityText } from '../RentalPortalMatch.utils'

function RentalPortalMatchEligibilityBadge({
  className,
  hasReason = true,
  height,
  match,
}) {
  const { t } = useTranslation()

  return (
    <Status
      showTooltip
      className={className}
      height={height}
      qaName={QA_NAME_MATCH_ELIGIBILITY_BADGE}
      text={getMatchEligibilityText({ hasReason, match, t })}
      textColor={MATCH_ELIGIBILITY_STATUSES[match.eligibility].textColor}
    />
  )
}

export default RentalPortalMatchEligibilityBadge
